import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

const SHELL_ID = 'twin_turbo_modal_shell';

export default class extends Controller {
  static values = {
    frame: String,
    title: String,
    url: String,
  };

  open(event) {
    event.preventDefault();

    if (this.#alreadyOpen()) {
      return;
    }

    const shell = document.getElementById(SHELL_ID);

    if (!shell) {
      throw new Error(`render UI::TwinTurboModal::Shell to open #${this.frameValue}`);
    }

    const modal = templateContent(shell);
    const frame = modal.querySelector('turbo-frame');

    modal.setAttribute('aria-label', this.titleValue);
    modal.querySelector('h2').textContent = this.titleValue;
    frame.id = this.frameValue;
    frame.setAttribute('src', this.urlValue || this.element.href);

    document.body.append(modal);
  }

  #alreadyOpen() {
    for (const frame of document.querySelectorAll(`turbo-frame#${CSS.escape(this.frameValue)}`)) {
      const dialog = frame.closest('dialog.ui--twin-turbo-modal');

      if (dialog?.open) {
        return true;
      }

      dialog?.remove();
    }

    return false;
  }
}
